import React from 'react'

const Courses = () => {
  return (
    <div>
      Courses Page
    </div>
  )
}

export default Courses
